import upperFirst from 'lodash/upperFirst'
import { compose, lifecycle, setDisplayName } from 'recompose'
import withStatus from 'hocs/bases/withStatus'
import withSnackBar from 'store/snackbar/withSnackBar'

const withDeleteResource = ({
  resourceName = 'resource',
  getAction,
  getOnActionSuccess,
  getSuccessMessage,
  getFailureMessage,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    setDisplayName(`With Delete ${ResourceName}`),
    withSnackBar,
    withStatus({
      actionName: `delete${ResourceName}`,
      statusName: `delete${ResourceName}Status`,
      getAction,
      getOnActionSuccess,
      getOnRequest: (props) => () => props.showMessage({ message: null }),
      getSuccessMessage: getSuccessMessage || (() => `${ResourceName} has been deleted.`),
      getFailureMessage: getFailureMessage || (() => `Cannot delete ${ResourceName}.`),
    }),
    lifecycle({
      componentWillReceiveProps(nextProps, nextContext) {
        const { [`delete${ResourceName}Status`]: nextDeleteStatus } = nextProps
        const { [`delete${ResourceName}Status`]: deleteStatus } = this.props
        if (
          deleteStatus.isRequest &&
          (
            nextDeleteStatus.isSuccess ||
            nextDeleteStatus.isFailure
          )
        ) {
          this.props.showMessage({ message: nextDeleteStatus.message })
        }
      },
    }),
  )
}

export default withDeleteResource


// WEBPACK FOOTER //
// ./src/hocs/bases/withDeleteResource.js